import { Link } from "react-router-dom";

import {
  countDoneSteps,
  GETTING_STARTED_STEPS,
  useGettingStartedQuery,
} from "@/hooks/use-getting-started";
import { Progress } from "@/components/ui/progress";

// The only way into the Getting started page: it has no menu item of its own.
export function GettingStartedCard() {
  const { data: progress } = useGettingStartedQuery();
  const done = progress ? countDoneSteps(progress) : 0;

  return (
    <Link
      to="/getting-started"
      className="block rounded-xl bg-background p-3 shadow-card transition-colors hover:bg-muted/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sidebar-ring"
    >
      <span className="flex items-center justify-between gap-2">
        <span className="text-[13px] font-medium">Getting started</span>
        {progress && (
          <span className="text-[13px] text-muted-foreground tabular-nums">
            {done} of {GETTING_STARTED_STEPS.length}
          </span>
        )}
      </span>
      <span aria-hidden="true" className="mt-3 block">
        <Progress
          value={done}
          max={GETTING_STARTED_STEPS.length}
          label="Getting started progress"
        />
      </span>
    </Link>
  );
}
